import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ModuleDetailsComponent } from './module.details/module.details.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'home/:reload',
    component: HomeComponent,
  },
  {
    path: 'module_details/:studentEid/:moduleId',
    component: ModuleDetailsComponent
  },
  {
    path: 'module_details/:studentEid/:moduleId/:aboutTheModule',
    component: ModuleDetailsComponent
  },
  {
    path: 'module_details/:studentEid/:moduleId/:aboutTheModule/:saveMode',
    component: ModuleDetailsComponent
  }  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
